// import {API_ENDPOINT} from '@env';
import ForgetPassword from '../components/Login/ForgetPassword';
import API from './api';

const API_ENDPOINT_RAW = process.env.REACT_APP_API_ENDPOINT || '';
const ISAFEVENTURES_ENDPOINT_RAW =
  process.env.REACT_APP_ISAFEVENTURES_ENDPOINT || '';
const ISAFE_DIRECT_ENDPOINT_RAW =
  process.env.REACT_APP_ISAFE_DIRECT_ENDPOINT || '';

export const API_ENDPOINT = API_ENDPOINT_RAW.replace(/\/+$/, '');
export const ISAFEVENTURES_ENDPOINT =
  ISAFEVENTURES_ENDPOINT_RAW.replace(/\/+$/, '');
export const ISAFE_DIRECT_ENDPOINT =
  ISAFE_DIRECT_ENDPOINT_RAW.replace(/\/+$/, '');
export const FILES_BASE_URL = API_ENDPOINT
  ? `${API_ENDPOINT}/sites/default/files`
  : '';
export const DOCS_BASE_URL = FILES_BASE_URL ? `${FILES_BASE_URL}/docs` : '';
export const RESOURCES_BASE_URL = FILES_BASE_URL
  ? `${FILES_BASE_URL}/resources`
  : '';
export const ADMINCENTRAL_IMAGE_BASE_URL = FILES_BASE_URL
  ? `${FILES_BASE_URL}/admincentral/image`
  : '';
const PIXEL_ENDPOINT =
  process.env.REACT_APP_PIXEL_ENDPOINT ||
  (process.env.NODE_ENV === 'development'
    ? '/api/pixel'
    : `${API_ENDPOINT}/api/pixel`);
// console.log('Endpoint: ' + API_ENDPOINT)
export const MONTHS = [
  {name: 'Jan.', fullname: 'January', daysInMonth: 31, monthNum: 1},
  {name: 'Feb.', fullname: 'February', daysInMonth: 29, monthNum: 2},
  {name: 'Mar.', fullname: 'March', daysInMonth: 31, monthNum: 3},
  {name: 'Apr.', fullname: 'April', daysInMonth: 30, monthNum: 4},
  {name: 'May.', fullname: 'May', daysInMonth: 31, monthNum: 5},
  {name: 'Jun.', fullname: 'June', daysInMonth: 30, monthNum: 6},
  {name: 'Jul.', fullname: 'July', daysInMonth: 31, monthNum: 7},
  {name: 'Aug.', fullname: 'August', daysInMonth: 31, monthNum: 8},
  {name: 'Sep.', fullname: 'September', daysInMonth: 30, monthNum: 9},
  {name: 'Oct.', fullname: 'October', daysInMonth: 31, monthNum: 10},
  {name: 'Nov.', fullname: 'November', daysInMonth: 30, monthNum: 11},
  {name: 'Dec.', fullname: 'December', daysInMonth: 31, monthNum: 12},
];

export const CONTACT_TYPE_OPTIONS = {
  le: [
    "ATF",
    "Chief of Police",
    "Deputy",
    "District Attorney",
    "DEA",
    "FBI",
    "Interpol",
    "LE Other",
    "Police",
    "Prosecutor",
    "Secret Service",
    "Sheriff",
    "School Resource Officer",
    "State Police",
    "US Attorney",
    "US Border Patrol",
    "US Citizenship and Immigration",
  ],
  ed: [
    "Administration",
    "Advisor",
    "Asst. Superintendent",
    "Consultant",
    "Counselor",
    " Community and Student Educator",
    " Curriculum Developer",
    "Director",
    "DOE",
    "Info Tech",
    " Library/Media Specialist ",
    "Principal",
    "School board/PTA member",
    "Superintendent",
    "Teacher",
    "Trainer",
    "Vice Principal",
    "Volunteer",
  ],
  hs: ["Parent", "Student"],
  op: ["Clergy", " Community and Student Educator", "Fifty+", "Parent"],
  eh: ["Professor", "Student", "Staff"],
  kt: ["Student", "Mentor"],
  me: ["Journalist", "Researcher"],
  ot: ["Other"],
};

export const MEMBERSHIP_LABELS = {
  kt: "Kids & Teens",
  eh: "Education Higher",
  ed: "Educators",
  hs: "Homeschool",
  op: "Parents/50+",
  le: "Law Enforcement",
  me: "Media",
  ot: "Other",
};


export const STATES = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  Test: 'DM',
};

export const STATES_SECONDARY = Object.fromEntries(
  Object.entries(STATES).map(([key, value]) => [value, key]),
);

//Object used for converting payload API values back into redux readable values
export const PROFILE_API_MAP = {
  first_name: 'first',
  last_name: 'last',
  email: 'mail',
  phone: 'phone',
  street: 'street',
  city: 'city',
  zip: 'zip',
  state: 'state',
};

export const API_ENDPOINTS = {
  userLogin : API_ENDPOINT + '/oauth/token',
  userToken : API_ENDPOINT + '/oauth/token',
  refreshUserToken: API_ENDPOINT + '/oauth/token',
  authorizationUrl: API_ENDPOINT + '/oauth/authorize',
  accessTokenUrl: API_ENDPOINT + '/oauth/token',
  loginOTP: API_ENDPOINT + '/api/user/otp?_format=json',
  verifyLoginOTP: API_ENDPOINT + '/api/user/verify-otp?_format=json',
  forgetPassword: API_ENDPOINT + '/api/user/forget-password?_format=json',
  forgetPasswordReset: API_ENDPOINT + '/api/user/forget-password-reset?_format=json',
  passwordReset: API_ENDPOINT + '/api/user/password-reset',
  pixel: API_ENDPOINT + '/api/pixel',

  /* SSO Logins */
  googleSSO: API_ENDPOINT + '/oauth/token',
  classLinkSSO: API_ENDPOINT + '/oauth/token',
  microsoftSSO: API_ENDPOINT + '/oauth/token',
  ssoLogin: API_ENDPOINT + '/oauth/token',
  encryptTokens: API_ENDPOINT + '/api/encrypt-tokens',

  getUserProfile: API_ENDPOINT + '/api/get/user-profile?_format=json',
  updateUserProfile: API_ENDPOINT + '/api/user/profile-update?_format=json',
  getSubscriptionVideos: API_ENDPOINT + '/api/get/videos?_format=json',
  getAnnouncements : API_ENDPOINT + '/api/get/announcements?_format=json',
  getCurriculum: API_ENDPOINT + '/api/get/curriculum?_format=json',
  updateUserEmail : API_ENDPOINT + '/api/user/email-update?_format=json',
  updateNewEmailOTP: API_ENDPOINT + '/api/user/new-email-otp?_format=json',
  verifyUpdateNewEmailOTP: API_ENDPOINT + '/api/user/verify-new-email-otp?_format=json',
  getZipByState: API_ENDPOINT + '/api/get/state-zip?_format=json',
  getSchoolByZip: API_ENDPOINT + '/api/get/schools-by-zip?_format=json',
  registerUser: API_ENDPOINT + '/api/user/register?_format=json',
  getContactType: API_ENDPOINT + '/api/get/contact-types?_format=json',
  getSchoolLevel: API_ENDPOINT + '/api/get/school-levels?_format=json',
  getSchoolLevels: API_ENDPOINT + '/api/get/school_levels?_format=json',
  getCountries : API_ENDPOINT + '/api/get/countries?_format=json',
  
  /* ILEARN Certifications */

  getILEARNModules: API_ENDPOINT + '/api/get/ilearn-modules?_format=json',
  getILEARNChapter: API_ENDPOINT + '/api/get/ilearn-module-chapters?_format=json',
  getILEARNChapters: API_ENDPOINT + '/api/get/ilearn-all-chapters?_format=json',
  // getILEARNUser: API_ENDPOINT + '/api/get/user-ilearn?_format=json', old
   getILEARNUser: API_ENDPOINT + '/api/get/user-ilearn-detail?_format=json',
  getILearnVideos : API_ENDPOINT + '/api/get/ilearn-videos?_format=json',
  updateILEARNUser: API_ENDPOINT + '/api/update/user-ilearn?_format=json',
  getUserCertificate: API_ENDPOINT + '/api/get/user-certificate-date?_format=json',

  /* Admin Central */
  getPOCChanges: API_ENDPOINT + '/api/get/pocs-changes?_format=json',
  // rejectPOC: API_ENDPOINT + '/api/subscription/reject-poc?_format=json',
  getAdminRoles: API_ENDPOINT + '/api/admincentral/get/admin-roles',
  getAdmins: API_ENDPOINT + '/api/admincentral/get/admins',
  addAdmin: API_ENDPOINT + '/api/admincentral/add/admin',
  revokeAdmin: API_ENDPOINT + '/api/admincentral/revoke/admin',
  getOrganizationType: API_ENDPOINT + '/api/admincentral/get/org-types',
  addOrganizationType: API_ENDPOINT + '/api/admincentral/add/org-type',
  updateOrganizationType: API_ENDPOINT + '/api/admincentral/update/org',
  deleteOrganizationType: API_ENDPOINT + '/api/admincentral/delete/org-type?_format=json',
  getProductCodes: API_ENDPOINT + '/api/admincentral/get/product-codes',
  addProductCodes: API_ENDPOINT + '/api/admincentral/add/product-code',
  updateProductCodes: API_ENDPOINT + '/api/admincentral/update/product-code',
  deleteProductCode: API_ENDPOINT + '/api/admincentral/delete/product-codes?_format=json',
  getSalesPerson : API_ENDPOINT + '/api/admincentral/get/sales-persons',
  getSalesRegion : API_ENDPOINT + '/api/admincentral/get/sales-regions',
  addSalesRegions: API_ENDPOINT + '/api/admincentral/add/sales-person',
  updateSalesPerson: API_ENDPOINT + '/api/admincentral/update/sales-person',
  updateSalesRegion: API_ENDPOINT + '/api/admincentral/update/sales-region',
  addSalesPerson: API_ENDPOINT + '/api/admincentral/add/sales-person?_format=json',
  getWebinars: API_ENDPOINT + '/api/admincentral/get/webinars',
  editWebinars: API_ENDPOINT + '/api/admincentral/update/webinar',
  addWebinar: API_ENDPOINT +'/api/admincentral/add/webinar',
  getWebinarsRegistered: API_ENDPOINT + '/api/admincentral/get/webinar-registered?_format=json',
  getEmailLog: API_ENDPOINT + '/api/admincentral/get/email-log',
  getReportLog: API_ENDPOINT + '/api/get/report-logs?_format=json',
  getPOC: API_ENDPOINT + '/api/get/poc/listing?_format=json',
  rejectPOC: API_ENDPOINT + '/api/subscription/reject-poc?_format=json',
  approvePOC: API_ENDPOINT + '/api/subscription/approve-poc-change?_format=json',
  searchOrganizations: API_ENDPOINT + '/api/admincentral/search/organizations',
  getOrganizationDetail: API_ENDPOINT + '/api/admincentral/get/org/detail?_format=json',
  searchUsers: API_ENDPOINT + '/api/admincentral/search/users',
  getUserDetail: API_ENDPOINT + '/api/admincentral/get/user/detail?_format=json',
  blockUser: API_ENDPOINT + '/api/user/block?_format=json',
  unblockUser: API_ENDPOINT + '/api/user/unblock?_format=json',
  getSubscriptionListing: API_ENDPOINT + '/api/get/subscriptions',
  getSubscriptionDetail: API_ENDPOINT + '/api/get/subscription-detail?_format=json',
  getResources: API_ENDPOINT + '/api/admincentral/get/resources?_format=json',
  addResources: API_ENDPOINT + '/api/admincentral/add/resource?_format=json',
  deleteResources: API_ENDPOINT + '/api/admincentral/delete/resource?_format=json',
  getRequestedQuotes : API_ENDPOINT + '/api/admincentral/get/requested-quotes?_format=json',
  processRequestedQuotes: API_ENDPOINT + '/api/admincentral/process/requested-quotes?_format=json',
  getSettings: API_ENDPOINT + '/api/admincentral/get/settings?_format=json',
  updatedSettings: API_ENDPOINT + '/api/admincentral/save/settings?_format=json',
  checkSTATImportRequirement: API_ENDPOINT + '/api/determine/statssheet/import?_format=json',
  
  
  /* Teachers */
  getSubscriptionTeachers: API_ENDPOINT + '/api/get/subscription-teachers?_format=json',
  sendWelcomeEmails: API_ENDPOINT + '/api/welcome/subscription-teachers?_format=json',
  getSubscriptionSchools: API_ENDPOINT + '/api/get/subscription-schools?_format=json',
  editSubscriptionTeacher: API_ENDPOINT + '/api/edit/teacher?_format=json',
  denySubscriptionTeacher: API_ENDPOINT + '/api/deny/teacher?_format=json',
  addSubscriptionTeacher: API_ENDPOINT + '/api/add/teacher?_format=json',
  certifySubscriptionTeacher: API_ENDPOINT + '/api/certify/teacher?_format=json',
  confirmAllCertification: API_ENDPOINT + '/api/certify/all-teachers-confirm?_format=json',
  certifyAllImplementation: API_ENDPOINT + '/api/certify/all-teachers?_format=json',
  confirmAllUncertification: API_ENDPOINT + '/api/uncertify/all-teachers-confirm?_format=json',
  uncertifySubscriptionTeacher: API_ENDPOINT + '/api/uncertify/teacher?_format=json',
  uncertifyAllImplementation: API_ENDPOINT + '/api/uncertify/all-teachers?_format=json',
  removeSubscriptionTeacher: API_ENDPOINT + '/api/remove/teacher?_format=json',
  exportTeachersList : API_ENDPOINT + '/api/export/teachers?_format=json',
  importTeacherList: API_ENDPOINT + '/api/import/teachers?_format=json',
  getTeacherDetail: API_ENDPOINT + '/api/get/teacher-detail?_format=json',
  selfImplementation: API_ENDPOINT + '/api/set/self-implementation?_format=json',
  getAdminAnnouncements: API_ENDPOINT + '/api/admincentral/get/announcements?_format=json',
  addAdminAnnouncements: API_ENDPOINT + '/api/admincentral/add/announcement?_format=json',
  editAdminAnnouncements: API_ENDPOINT + '/api/admincentral/edit/announcement?_format=json',
  deleteAdminAnnouncements: API_ENDPOINT + '/api/admincentral/delete/announcement?_format=json',
  adminMergeAccount: API_ENDPOINT + '/api/admincentral/merge/accounts?_format=json',
  adminSearchOrgsForMerge: API_ENDPOINT + '/api/admincentral/search/organizations-merge?_format=json',
  adminMergeOrganizations: API_ENDPOINT + '/api/admincentral/merge/organizations?_format=json',
  importInvoice : API_ENDPOINT + '/api/subscription/import-invoice?_format=json',
  getSchools: API_ENDPOINT + '/api/get/schools?_format=json',
  exportSchoolList : API_ENDPOINT + '/api/export/schools?_format=json',
  importSchoolList: API_ENDPOINT + '/api/import/schools?_format=json',
  removeSchool : API_ENDPOINT + '/api/remove/school?_format=json',
  changeSchool: API_ENDPOINT + '/api/change/school?_format=json',
  importSchool: API_ENDPOINT + '/api/import/schools/org_id',
  searchNCES: API_ENDPOINT + '/api/search/schools/nces?_format=json',
  searchNCESID: API_ENDPOINT + '/api/search/schools/ncesid?_format=json',
  resetUserPassword: API_ENDPOINT + '/api/user/reset-user-password?_format=json',
  verifyTeacherEmail : API_ENDPOINT + '/api/verify/teacher-email?_format=json',
  getTeacherProfile: API_ENDPOINT + '/api/get/teacher-profile?_format=json',
  getTeacherImplementations: API_ENDPOINT + '/api/get/teacher-implementations?_format=json',
  getTeacherImplementationsNew: API_ENDPOINT +'/api/get/teacher-implementations_new?_format=json',
  countUserLogin: API_ENDPOINT + '/api/count/user-login',
  getTeacherSubscriptions: API_ENDPOINT + '/api/get/teacher-subscription?_format=json',
  updateTeacherImplementation: API_ENDPOINT + '/api/update/teacher-implementation?_format=json',
  getCityByState: API_ENDPOINT + '/api/get/state-city?_format=json',
  getSchoolsByCity: API_ENDPOINT + '/api/get/city-schools?_format=json',
  getSchoolId: API_ENDPOINT + '/api/get/school-id?_format=json',
  reimportStatSheet: API_ENDPOINT + '/api/re-import/statssheet',
  getSTATs: API_ENDPOINT + '/api/get/stats',
  getTeachersBySchool: API_ENDPOINT + '/api/get/school/teachers?_format=json',

  /* Quotes */

  submitRenewalQuote : API_ENDPOINT + '/api/request/quote?_format=json',
  getRenewalQuote: API_ENDPOINT + '/api/get/quotes?_format=json',
  requestInternalQuote: API_ENDPOINT + '/api/request/quote-internal?_format=json',
  getExternalQuote: API_ENDPOINT + '/api/get/external-quotes?_format=json',
  exportAllQuotesCSV: API_ENDPOINT + '/api/export/quote-csv-all?_format=json',
  exportQuotePDF: API_ENDPOINT + '/api/export/quote/pdf?_format=json',
  exportQuoteCSV: API_ENDPOINT + '/api/export/quote-csv?_format=json',

  /* Get Admin Users */

  getAdminUsers: API_ENDPOINT + '/api/get/admin-users?_format=json',
  addAdminUsers: API_ENDPOINT + '/api/add/admin?_format=json',
  revokeAdminUsers: API_ENDPOINT + '/api/revoke/admin?_format=json',
  updatePOC: API_ENDPOINT + '/api/update/poc?_format=json',

  /* Reports */

  downloadCertificationReport: API_ENDPOINT + '/api/report/certification/pdf?_format=json',
  downloadCertificationReportCSV: API_ENDPOINT + '/api/report/certification/csv?_format=json',
  downloadEducatorReport: API_ENDPOINT + '/api/report/educators/pdf?_format=json',
  downloadEducatorReportCSV: API_ENDPOINT + '/api/report/educators/csv?_format=json',
  downloadERATECertReport: API_ENDPOINT + '/api/report/educator-eratecert/pdf?_format=json',
  downloadERATECertReportCSV: API_ENDPOINT + '/api/report/educator-eratecert/csv?_format=json',
  downloadPendingERATECertReport: API_ENDPOINT + '/api/report/pending-eratecert/pdf?_format=json',
  downloadPendingERATECertReportCSV: API_ENDPOINT + '/api/report/pending-eratecert/csv?_format=json',
  downloadComplianceDocReport: API_ENDPOINT + '/api/report/implementation/pdf?_format=json',
  downloadEducatorModuleDownloadReport: API_ENDPOINT + '/api/report/all-module-download/pdf?_format=json',
  downloadOtherCSMReport: API_ENDPOINT + '/api/report/other-csm/csv?_format=json',
  downloadOtherCSMReportCSV : API_ENDPOINT + '/api/report/other-csm/csv?_format=json',
  downloadEducatorParticipatingCSV : API_ENDPOINT + '/api/report/educators-participating/csv?_format=json',
  downloadModuleDownloadCSV : API_ENDPOINT + '/api/report/module-download/csv?_format=json',
  downloadEdBrowserDownloadCSV : API_ENDPOINT + '/api/report/edbrowser-download/csv?_format=json',
  downloadParticipatingSchoolsCSV: API_ENDPOINT + '/api/report/participating-schools/csv?_format=json',
  downloadStudentTeacherGradeCSV : API_ENDPOINT + '/api/report/students-educator/csv?_format=json',

  /* ISAFE AI*/
  getChatbotResponse: API_ENDPOINT + '/api/edbrowser/lexbot?_format=json',


  //Incident Reporting 
  getIncidentReport: API_ENDPOINT + '/api/incidents/get?_format=json',
};

// Feature flags and misc app-wide toggles
export const ENABLE_CHATBOT_RECAPTCHA =
  (process.env.REACT_APP_ENABLE_CHATBOT_RECAPTCHA || 'true') === 'true';
